import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import * as Sentry from '@sentry/ember';
import { initializeVdrClient } from 'scaleflow/utils/aws-clients/s3VDRClient';

class BacklogInitiativesInitiativeKnowledgeBaseFileFileNameRoute extends Route {
  @service router;
  @service store;

  async model({ file_name }) {
    if (!file_name) throw new Error('File name is required to fetch the file.');

    const client = await initializeVdrClient(this.store);
    const file = await client.fileExists(file_name);
    if (!file) {
      throw new Error('File not found');
    }

    const initiative = this.modelFor('backlog.initiatives.initiative');

    return {
      initiative,
      file_name,
    };
  }

  @action
  error(error) {
    if (error?.message !== 'File not found') {
      Sentry.captureException(error);
    }
    this.router.transitionTo(
      'backlog.initiatives.initiative.knowledge-base.list',
    );
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeKnowledgeBaseFileFileNameRoute,
);
